import { MD3DarkTheme, DefaultTheme } from 'react-native-paper';

export const colors = {
  primary: '#FFFFFF', // White for text and accents
  secondary: '#B0B0B0', // Muted gray for secondary text
  background: '#111111', // Pure black background
  surface: '#181818', // Slightly lighter than background
  text: '#FFFFFF', // Main text is white
  textSecondary: '#B0B0B0', // Secondary text
  error: '#FF5252',
  success: '#00FF9D',
  warning: '#FFD93D',
  info: '#FFFFFF', // Use white for info/links
  divider: '#232323', // Very dark gray divider
  card: '#181818',
  tabBar: '#111111',
  tabBarInactive: '#757575',
  tabBarActive: '#FFFFFF',
  accent1: '#FFFFFF',
  accent2: '#B0B0B0',
  accent3: '#232323',
  accent4: '#181818',
};

export const spacing = {
  xs: 4,
  sm: 8,
  md: 16,
  lg: 24,
  xl: 32,
  xxl: 48,
};

export const typography = {
  fontFamily: {
    regular: 'System', // Use system sans-serif for body
    medium: 'System',
    bold: 'System',
    serif: 'Georgia', // Use Georgia as a modern serif for headlines (swap for custom if desired)
  },
  fontSize: {
    xs: 13,
    sm: 15,
    md: 18,
    lg: 22,
    xl: 28,
    xxl: 36,
    xxxl: 48,
  },
  lineHeight: {
    xs: 18,
    sm: 22,
    md: 28,
    lg: 32,
    xl: 38,
    xxl: 44,
    xxxl: 56,
  },
};

export const shadows = {
  small: {
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.04,
    shadowRadius: 1,
    elevation: 1,
  },
  medium: {
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.06,
    shadowRadius: 2,
    elevation: 2,
  },
  large: {
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.08,
    shadowRadius: 4,
    elevation: 4,
  },
};

export const theme = {
  ...MD3DarkTheme,
  colors: {
    ...MD3DarkTheme.colors,
    primary: colors.primary,
    secondary: colors.secondary,
    background: colors.background,
    surface: colors.surface,
    text: colors.text,
    error: colors.error,
    accent: colors.accent1,
  },
  spacing,
  typography,
  shadows,
  fonts: {
    ...DefaultTheme.fonts,
    regular: {
      fontFamily: 'Inter_400Regular',
      fontWeight: '400',
    },
    medium: {
      fontFamily: 'Inter_500Medium',
      fontWeight: '500',
    },
    light: {
      fontFamily: 'Inter_400Regular',
      fontWeight: '400',
    },
    thin: {
      fontFamily: 'Inter_400Regular',
      fontWeight: '400',
    },
  },
}; 
